import styled from 'styled-components'
import { Flex, Box } from 'vvs-uikit'

export const StyledQuestDetailFlex = styled(Flex)`
  width: 100%;
  background: white;
  background-repeat: repeat-x;
  flex-direction: column;
`

export const StyledTabItem = styled(Flex)`
  flex-direction: column;
  align-items: center;
`

export const CategoryBg = styled(Box)<{ bg?: string }>`
  ${({ bg }) =>
    bg &&
    `
    background-image: url('${bg}');
    background-size: cover;
    background-position: top center;
  `}
`
